module.exports = __webpack_public_path__ + "img/user-13.57128a47.svg";